import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

/**
 * Navigation buttons for moving between lessons.
 */
@Component({
  selector: 'ut-lesson-navigation',
  templateUrl: './lesson-navigation.component.html',
  styleUrls: ['./lesson-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LessonNavigationComponent {
  @Input() hasPrevious: boolean = false;
  @Input() hasNext: boolean = false;
  @Input() isFirstLesson: boolean = false;
  @Input() isLastLesson: boolean = false;
  @Input() hasQuiz: boolean = false;
  @Input() isQuizAvailable: boolean = false;

  @Output() previousClick = new EventEmitter<void>();
  @Output() continueClick = new EventEmitter<void>();
  @Output() quizClick = new EventEmitter<void>();
  @Output() finishClick = new EventEmitter<void>();

  onPreviousClick(): void {
    if (this.hasPrevious) {
      this.previousClick.emit();
    }
  }

  onContinueClick(): void {
    if (this.isLastLesson && this.hasQuiz) {
      this.quizClick.emit();
    } else if (this.isLastLesson && !this.hasQuiz) {
      this.finishClick.emit();
    } else if (this.hasNext) {
      this.continueClick.emit();
    }
  }

  get continueButtonText(): string {
    if (this.isLastLesson && this.hasQuiz) {
      return 'Take Quiz';
    }
    return this.isLastLesson ? 'Finish' : 'Continue';
  }

  get isContinueDisabled(): boolean {
    if (this.isLastLesson && this.hasQuiz) {
      return !this.isQuizAvailable;
    }
    if (this.isLastLesson && !this.hasQuiz) {
      return false;
    }
    return !this.hasNext;
  }
}
